<script>
import dateMixin from "@/mixins/dateMixin";
import accountMixin from "@/mixins/accountMixin";
import orderMixin from "@/mixins/orderMixin";

export default {
  mixins: [dateMixin, accountMixin, orderMixin],

  props: {
    order: {
      type: Object,
      required: true
    }
  }
};
</script>

<template>
  <v-container>
    <v-layout column justify-center class="section-title">
      <div>reagendar pedido</div>
      <hr />
    </v-layout>

    <v-layout column align-center>
      <div>
        <img
          :src="order.professional.account.profile.profile_picture"
          :alt="order.professional.account.first_name"
        />
      </div>
      <div class="text-capitalize">
        {{ order.professional.account | fullName }}
      </div>
      <div>
        {{
          order.schedule_event.starts_at
            | formatDate("dddd, D/MM/YYYY [às] HH[hrs]")
        }}
      </div>
      <div>
        <b>Duração:</b>
        {{ order.schedule_event.duration | durationInHous }}
      </div>
    </v-layout>
  </v-container>
</template>

<style scoped>
img {
  height: 100px;
  border-radius: 100%;
  border: 4px solid #f1f1f1f1;
}
</style>



// WEBPACK FOOTER //
// src/components/Orders/Rebooking/Details.vue